import { DateTime } from 'luxon';

import DatadogApi from '@/common/apis/DatadogApi';
import { getDiff } from '@/utils/Diff';
import Validatable from '@/validator/Validatable';

export default class MastercardAudienceLogic extends Validatable {
  constructor(
    public id: number = -1,
    public name: string = '',
    public segmentIDs: string[] = [],
    public timestamp: DateTime = DateTime.local(),
    public createdOnUtc = null,
    public modifiedOnUtc = null,
    public apiObject = null,
  ) {
    super();
  }

  static fromObject(obj) {
    return super.fromObject(
      obj,
      new MastercardAudienceLogic(
        obj.id,
        obj.name,
        obj.segmentIDs,
        obj.timestamp,
        obj.createdOnUtc,
        obj.modifiedOnUtc,
        obj.apiObject,
      ),
    );
  }

  isPristine(): boolean {
    if (this.isNew) return true;
    const ignoreProperties = ['created_on_utc', 'modified_on_utc', 'timestamp'];
    const diffs = getDiff(this.apiObject, this.toApi(), ignoreProperties);
    if (diffs.length === 0) return true;
    DatadogApi.logUnexpectedChange(diffs);
    return false;
  }

  static fromApi(apiObject) {
    if (!apiObject.timestamp) {
      apiObject.timestamp = DateTime.local().toISODate();
    }

    const audienceLogic = MastercardAudienceLogic.fromObject({
      id: apiObject.audiencelogic_id,
      name: apiObject.name,
      segmentIDs: apiObject.segment_ids,
      timestamp: DateTime.fromISO(apiObject.timestamp),
      createdOnUtc:
        apiObject.created_on_utc != null ? DateTime.fromISO(apiObject.created_on_utc, { zone: 'utc' }) : null,
      modifiedOnUtc:
        apiObject.modified_on_utc != null ? DateTime.fromISO(apiObject.modified_on_utc, { zone: 'utc' }) : null,
    });
    audienceLogic.apiObject = apiObject;
    return audienceLogic;
  }

  toApi() {
    return {
      mc_segment_ids: this.segmentIDs,
      name: this.name,
    };
  }
}
